export default __webpack_public_path__ + "static/media/science-img-five.85333569.png";